module.exports = __webpack_public_path__ + "static/media/StatsJumbo.a3475686.png";